import React from "react";
import ReactPlayer from "react-player";

import Layout from "../../components/layout";
import SEO from "../../components/seo";
import styles from "./video-only.module.css";

import { connect } from "react-redux";
import { completeModule } from "../../state/actions";

let playerRef;

const RightsAndResponsibilities = props => (
  <Layout>
    <SEO
      title="Module - Rights and Responsiblities"
      keywords={["utah foster care", "foster care"]}
    />
    <div className={styles.moduleGridContainer}>
      <h1 className={styles.videoTitle}>Rights and Responsibilities</h1>
      <div className={styles.container}>
        <ReactPlayer
          ref={c => (playerRef = c)}
          className={styles.reactPlayer}
          url="https://www.youtube.com/embed/KJxa77-oVjk"
          controls
          height="100%"
          width="100%"
          onEnded={() => {
            playerRef.seekTo(0);
            props.markComplete();
          }}
        />
      </div>
    </div>
  </Layout>
);

const stateToProps = () => ({});

const dispatchToProps = dispatch => {
  return {
    markComplete() {
      dispatch(completeModule(3));
    }
  };
};

export default connect(
  stateToProps,
  dispatchToProps
)(RightsAndResponsibilities);
